<div class="slide-menu" *ngIf="!isMobile">
    <ul class="slide-menu__bar" id="bar">
        <li class="slide-menu__bar-item slide-menu__bar-item__active" *ngIf="item.itemActive">{{item.itemActive}}</li>
        <li class="slide-menu__bar-item" *ngIf="item.item">{{item.item}}</li>
        <li class="slide-menu__bar-item" *ngIf="item.subItem">{{item.subItem}}</li>
    </ul>
</div>
